import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../core/authentication.service';
import { AppSettings } from '../shared/App-Settings';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class DirectServiceRatesService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) { }

  ImportDirectServiceRates() {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}countryZoneRates`;
    return this.httpClient.get<any>(url, httpOptions);
  }
}
